import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

// (tip move them in a JSON file and import them)
// todo: add en translations as default
const resources = {
  ru: {
    translation: {
      ERROR_TRANSLATION_NOT_FOUND: 'Translation file not found for {{locale}}.',
      ERROR_FORM_FIELD_REQUIRED: 'This field is required.',
    },
  },
};

export const defaultLanguage = 'en';

i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: defaultLanguage,
    defaultNS: 'tim',

    keySeparator: false, // we do use keys in form messages.welcome

    saveMissing: true,

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    returnNull: false,
  })
  .catch(console.error);

export const i18n = i18next;
